export function useClipboard() {
  const isSupported = navigator.clipboard && window.isSecureContext

  const copy = async (text: string): Promise<boolean> => {
    if (!text) return false

    try {
      if (isSupported) {
        await navigator.clipboard.writeText(text)
        return true
      } else {
        // Fallback for older browsers or non-secure contexts
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        const success = document.execCommand('copy')
        document.body.removeChild(textArea)
        return success
      }
    } catch (error) {
      console.error('Failed to copy text:', error)
      return false
    }
  }

  return {
    copy
  }
}